import { AddonState } from 'src/store/addon/types';

const clearClipArtCategoriesReducer = (state: AddonState) => {
  state.clipArtCategories = {};
};

export default clearClipArtCategoriesReducer;
